import {
  useCreateInternalTransferDisbursementMutation,
  useDeleteInternalTransferDisbursementMutation,
  useUpdateInternalTransferDisbursementMutation,
} from 'API/order/escrow/InternalTransferDisbursementAPI';
import { IEscrowFileCompleteData } from 'types/order/escrow/IEscrowFileCompleteData';
import { ICreateInternalTransferDisbursement } from 'types/order/escrow/internalTransferDisbursements/ICreateInternalTransferDisbursement';
import { IInternalTransferDisbursementFormData } from 'types/order/escrow/internalTransferDisbursements/IInternalTransferDisbursementFormData';
import { IUpdateInternalTransferDisbursement } from 'types/order/escrow/internalTransferDisbursements/IUpdateInternalTransferDisbursement';
import { assertDefined } from 'utilities/Assertions';

export const useProcessInternalTransfer = (orderId: string, escrowFile?: IEscrowFileCompleteData) => {
  const [onCreate] = useCreateInternalTransferDisbursementMutation();
  const [onUpdate] = useUpdateInternalTransferDisbursementMutation();
  const [onDelete] = useDeleteInternalTransferDisbursementMutation();

  return (internalTransferForm: IInternalTransferDisbursementFormData) => {
    const {
      isNew,
      isDeleting,
      amountCents,
      holdback = false,
      statementFeeId,
      category,
      destinationAccountId,
      holdbackProperties,
      ...internalTransfer
    } = internalTransferForm;

    if (isDeleting) {
      return onDelete({ orderId, internalTransferId: internalTransfer.id });
    }

    if (isNew) {
      const { id: escrowFileId, depositEscrowBankAccount } = escrowFile ?? {};
      const { id: sourceAccountId } = depositEscrowBankAccount ?? {};
      assertDefined(escrowFileId);
      assertDefined(sourceAccountId);
      assertDefined(statementFeeId);

      const newInternalTransfer: ICreateInternalTransferDisbursement = {
        amountCents,
        holdback,
        holdbackProperties,
        category,
        destinationAccountId,
        escrowFileId,
        orderId,
        statementFeeId,
        sourceAccountId,
        unrestricted: false,
      };
      return onCreate(newInternalTransfer);
    }
    const updateInternalTransfer: IUpdateInternalTransferDisbursement = {
      orderId,
      id: internalTransfer.id,
      amountCents,
      holdback,
      holdbackProperties,
      category,
      destinationAccountId,
    };
    return onUpdate(updateInternalTransfer);
  };
};
